module.exports = require('./dist/commonjs/index.js').default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/i18next-xhr-backend/index.js
// module id = 1432
// module chunks = 0